/* eslint-disable @nx/enforce-module-boundaries */
'use-client';
import {
  AmexIcon,
  BoxMinus,
  BoxPlus,
  CardIcon,
  CheckMark,
  CheckMark1,
  MastercardIcon,
  QuestionIcon,
  QuestionOutlineIcon,
  VisaIcon,
  CirclePlusBg,
  LockIcon,
  BackArrow,
  AddCircleFIlled,
  JobsIconColored,
} from '@mybridge/icons';
import {
  Box,
  Card,
  CardBody,
  Flex,
  HStack,
  Heading,
  IconButton,
  Radio,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  Spacer,
  Tooltip,
  Portal,
  Stack,
  Select,
  VStack,
  CardHeader,
  ListItem,
  List,
  RadioGroup,
  CircularProgress,
} from '@mybridge/ui';
import { Button } from '@mybridge/ui/button';
import { useEffect, useState } from 'react';
// import questionIcon from '@mybridge/icons/questionIcon';
import {
  Icon,
  Table,
  TableContainer,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
  SimpleGrid,
} from '@chakra-ui/react';
import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
} from '@mybridge/ui/modal';
import { Text } from '@mybridge/ui/text';
import _ from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import {
  getDiskSubscriptionPlan,
  getUserSubscriptionDetails,
  processDiskSubscription,
  diskSubscriptionInit,
  getPremiumSubscriptionPlans,
  getOccupiedDiskSize,
  getPremiumSubscription,
} from 'v4/store/actions/myDisk.Action';
import { humanFileSize } from 'v4/components/utils';
import { ArrowRight, MyBridgeSupscriptionIcon } from '@mybridge/icons';
import { cardList } from 'v4/store/slices/paymentSlice';
import { validatePromoCode } from 'v4/store/actions/payments.actions';
import { Input, InputGroup, InputRightElement } from '@mybridge/ui/input';
import { CloseIcon } from '@chakra-ui/icons';
import JobSubscriptionPage from '../../page/jobs/subscription/[...id]/index';
import { useToast } from '@chakra-ui/react';
import SectionLoader from 'v4/components/common/loader/sectionLoader';
import QuantityInputBox from 'v4/components/common/QuantityInput';
import moment from 'moment';
import Link from 'next/link';
import { AuthenticatedProviders } from 'v4/snippets/providers/authenticated';
import { getAllCompanyTypePages } from 'v4/store/actions/companyPages.actions';
import { JobsNotFoundIllustration } from 'v4/snippets/jobs/404';
import PremiumSubscription from 'v4/snippets/premium';
import { useRouter } from 'next/router';
import { isMobile, isMobileOnly } from 'react-device-detect';
import { StackDivider } from '@chakra-ui/react';
import Head from 'next/head';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';
import { useDirection } from '@mybridge/ui/custom-hooks/useDirection';
import { ANALYTICS_EVENTS, trackEvent } from 'v4/utils/analyticsEvents';
export default function DiskSubscription({ setSelectedComponent, fromSettings=true }) {
  const dispatch = useDispatch();
  const { t } = useTranslator();
  const direction = useDirection();
  const router = useRouter();
  const toast = useToast();
  const currentDate = moment();
  const {
    subscriptionPlans,
    userSubscription,
    loading,
    userSubscriptionExists,
    occupiedSize,
    premiumSubscriptionDetails,
    premiumSubscriptionPlans,
  } = useSelector((state) => state.myDisk) ?? {};
  const { companyPageTypeList } = useSelector((state) => state.companyPage);
  const { loggedIn, pageLoaded } = useSelector((state) => state.user);
  const { globalNotifCount } = useSelector((state) => state.notifications);
  const { cardInfo } = useSelector((state) => state.payment);
  const [paymentPeriod, setPaymentPeriod] = useState('monthly');
  const [selectedPlan, setSelectedPlan] = useState();
  const [selectedPlanPeriod, setSelectedPlanPeriod] = useState();
  const [stripeProdId, setStripeProdId] = useState();
  const [stripePriceId, setStripePriceId] = useState();
  const [paymentModal, setPaymentModal] = useState(false);
  const [currentPlan, setCurrentPlan] = useState();
  const [currentPlanID, setCurrentID] = useState();
  const [tabIndex, setTabIndex] = useState(0);
  const [activeSubView, setActiveSubView] = useState(null);
  const order = { 1: 1, 3: 2, 2: 3 };
  const [diskBilledAs, setDiskBilledAs] = useState('price_monthly');
  const [premiumBilledAs, setPremiumBilledAs] = useState('price_monthly');
  const [selectedCompany, setSelectedCompany] = useState(null);

  // const offerPayload = {
  //   hasOffer: true,
  //   offerTitle: 'Special Offer Discount',
  //   offerCode: 'OFFER25',
  //   discountAmount: 5.00,
  // };
  // const [isOfferApplied, setIsOfferApplied] = useState(false);
  const [showOfferInput, setShowOfferInput] = useState(false);
  const [offerCodeInput, setOfferCodeInput] = useState('');
  const [appliedOffer, setAppliedOffer] = useState(null);
  const [offerLoading, setOfferLoading] = useState(false);
  const [offerError, setOfferError] = useState('');

  const handleApplyOffer = async () => {
    if (!offerCodeInput || !offerCodeInput.trim()) return;
    setOfferLoading(true);
    setOfferError('');
    try {
      const res = await dispatch(
        validatePromoCode({
          code: offerCodeInput.trim(),
          service_type: 'DISK',
          billed_type: diskBilledAs === 'price_monthly' ? 'monthly' : 'yearly',
          // amount: (selectedPlan?.price || 19.99).toFixed(2),
          amount: (parseFloat(selectedPlan?.id === 1 ? selectedPlan?.amount : selectedPlan?.[selectedPlanPeriod || (diskBilledAs === 'price_monthly' ? 'month_amount' : 'year_amount')]) || 0).toFixed(2),
        })
      );
      if (res?.payload?.valid) {
        setAppliedOffer(res.payload);
        setOfferError('');
      } else {
        setOfferError(res?.payload?.message || 'Invalid offer code');
      }
    } catch (err) {
      setOfferError('Failed to validate offer code');
    } finally {
      setOfferLoading(false);
    }
  };

  const handleRemoveOffer = () => {
    setAppliedOffer(null);
    setOfferCodeInput('');
    setOfferError('');
  };

  useEffect(() => {
    setAppliedOffer(null);
    setOfferCodeInput('');
    setOfferError('');
    setShowOfferInput(false);
  }, [diskBilledAs]);

  useEffect(() => {
    dispatch(getDiskSubscriptionPlan());
    dispatch(getPremiumSubscriptionPlans());
    dispatch(getUserSubscriptionDetails());
    dispatch(getOccupiedDiskSize());
    dispatch(getPremiumSubscription());
    // if (companyPageTypeList?.length === 0) {
      dispatch(getAllCompanyTypePages());
    // }
  }, []);
  const mapSubscriptions = _.orderBy(subscriptionPlans, (o) => order[o.id]);
  const allSubscriptions = {};
  mapSubscriptions?.forEach(
    (plan) => (allSubscriptions[plan.code] = plan.features_list)
  );

  const defaultCard = _.find(cardInfo?.cards, {
    id: cardInfo?.default_card_id,
  });

  const handlePaymentPeriod = (e) => {
    setPaymentPeriod(e);
  };

  const calculatePrice = (price) => {
    const newPrices = price / 12;
    return _.round(newPrices, 2);
  };

  const { userProfileInfo } = useSelector((state) => state.userProfile);

  const getUserSlug = () => {
    return userProfileInfo?.slug || userProfileInfo?.username || null;
  };

  const trackSubscription = () => {
    const userSlug = getUserSlug();
    if (!userSlug) return;

    trackEvent(ANALYTICS_EVENTS.SubscriptionList, userSlug, {
      timestamp: new Date().toISOString()
    });
  };

  useEffect(() => {
    if (userProfileInfo) {
      trackSubscription();
    }
  }, []);

  useEffect(() => {
    if (userSubscription === undefined || userSubscription.length === 0) {
      dispatch(
        diskSubscriptionInit({
          expires_at: currentDate.add(6, 'months').utc().format('YYYY-MM-DD'),
        })
      );
    }
    if (userSubscription) {
      setCurrentPlan(userSubscription ? userSubscription[0] : '');
      setCurrentID(
        userSubscription ? userSubscription[0]?.disk_plan?.id : null
      );
    }
  }, [userSubscription, loading]);

  const handleBuyPackage = (subscription) => {
    dispatch(cardList());

    setSelectedPlanPeriod(
      diskBilledAs === 'price_monthly' ? 'month_amount' : 'year_amount'
    );
    setSelectedPlan(subscription);
    setPaymentModal(true);
  };

  const displayCardIcon = (brand) => {
    switch (brand) {
      case 'visa':
        return <VisaIcon />;
      case 'mastercard':
        return <MastercardIcon />;
      case 'amex':
        return <AmexIcon />;
      default:
        return <CardIcon />;
    }
  };

  const handleClose = () => {
    setPaymentModal(false);
  };

  const handleDiskBilledAs = (e) => {
    setDiskBilledAs(e.target.value);
  };

  const handlePaymentSubmit = async (selectedPlan) => {
    const payload = {
      // plan_id: selectedPlan?.id,
      stripe_price_id:
        selectedPlan?.id === 1
          ? selectedPlan?.price_id
          : diskBilledAs === 'price_monthly'
          ? selectedPlan?.month_price_id
          : selectedPlan?.year_price_id,
      billed_type: diskBilledAs === 'price_monthly' ? 'monthly' : 'yearly',
      ...(appliedOffer?.valid && appliedOffer?.code ? { promo_code: appliedOffer.code } : {}),
    };
    dispatch(processDiskSubscription(payload)).then((res) => {
      if (res) {
        if(res?.payload?.status_code>=400){
          toast({
            title: res?.payload?.detail || "Failed to upgrade plan!",
            status: 'error',
            isClosable: true,
          });
        }else{
          toast({
            title: t('settingsSubscription.planUpdated') || 'Failed to update disk subscription',
            status: 'success',
            isClosable: true,
          });
          
          // Check if we need to redirect to disk page after subscription
          if (typeof window !== 'undefined') {
            const shouldRedirect = localStorage.getItem('redirectAfterDiskSubscription');
            if (shouldRedirect === 'true') {
              localStorage.removeItem('redirectAfterDiskSubscription');
              // Redirect to profile disk page after a short delay to allow toast to show
              setTimeout(() => {
                router.push('/profile/disk');
              }, 2000);
            }
          }
        }
        setPaymentModal(false);
        setSelectedPlan();
        setSelectedPlanPeriod();
        dispatch(getUserSubscriptionDetails());
      }
    });
  };

  useEffect(() => {
    if (router?.query?.subscription === 'premium') {
      setTabIndex(2);
    }
  }, [router]);


  const totalSizeGB = currentPlan?.disk_plan?.storage ?? 2.25;
  const totalSizeBytes = totalSizeGB * 1000 * 1000;
  const occupiedBytes = occupiedSize?.occupied_size ?? 0;
  const occupiedSizeStr = humanFileSize(occupiedBytes, true, 2);
  const totalSizeStr = humanFileSize(totalSizeBytes, true, 2);
  const percentUsed = totalSizeBytes > 0 ? Math.min(100, (occupiedBytes / totalSizeBytes) * 100).toFixed(2) : '0.00';
  const isOutOfStorage = percentUsed >= 100;

  const isPremiumSubscribed = premiumSubscriptionDetails && premiumSubscriptionDetails?.id && !premiumSubscriptionDetails?.expired && premiumSubscriptionDetails?.status_code !== 500;

  const renderDashboard = () => (
    <VStack align="stretch" spacing={6} maxW="900px" w="100%">
      <Text fontSize="xl" fontWeight="semibold" color="#4F4F4F">
        Subscriptions
      </Text>
      <SimpleGrid columns={{ base: 1, md: 2 }} spacing={5} w="100%">
        {/* myDisk Card */}
        <Card 
          p={5} 
          variant="thinBorderedCard" 
          cursor="pointer" 
          onClick={() => { 
            setActiveSubView('disk'); 
            setTabIndex(0); 
          }} 
          position="relative" 
          borderWidth="1px" 
          borderRadius="12px"
          boxShadow="sm"
          transition="all 0.2s"
          _hover={{
            boxShadow: 'md',
          }} 
        >
          <VStack align="start" spacing={4} height="100%" justifyContent="space-between">
            <VStack align="start" spacing={3} w="100%">
              <HStack justifyContent="space-between" w="100%">
                <CircularProgress
                  value={percentUsed}
                  size="48px"
                  thickness="10px"
                  color={isOutOfStorage ? '#9B0032' : '#3D5A80'}
                  trackColor={isOutOfStorage ? '#9B0032' : '#BCBCBD'}
                />
                <ArrowRight color="#868585" />
              </HStack>
              <Box mt={1}>
                <Text fontWeight="bold" fontSize="md" color="#4F4F4F">
                  myDisk ({currentPlan?.disk_plan?.plan_name || 'Basic'})
                </Text>
                <Text fontSize="sm" color="#868585" mt={1}>
                  {isOutOfStorage ? 'Out of storage (100% full)' : `${percentUsed}% used (${occupiedSizeStr} / ${totalSizeStr})`}
                </Text>
              </Box>
            </VStack>
            <Button
              size="sm"
              borderRadius="20px"
              w="120px"
              variant="primary"
              onClick={(e) => {
                e.stopPropagation();
                setActiveSubView('disk');
                setTabIndex(0);
              }}
            >
              Upgrade
            </Button>
          </VStack>
        </Card>

        {/* Job Subscription Card */}
        <Card 
          variant="thinBorderedCard" 
          p={5} 
          cursor="pointer" 
          onClick={() => { 
            // setActiveSubView('job'); 
            setSelectedCompany(null);
            setActiveSubView('job'); 
            setTabIndex(1); 
          }} 
          position="relative" 
          borderWidth="1px" 
          borderRadius="12px"
          boxShadow="sm"
          transition="all 0.2s"
          _hover={{
            boxShadow: 'md',
          }} 
        >
          <VStack align="start" spacing={4} height="100%" justifyContent="space-between">
            <VStack align="start" w="100%">
              <HStack justifyContent="space-between" w="100%">
                <JobsIconColored width="44" height="36" />
                <ArrowRight color="#868585" />
              </HStack>
              <Box>
                <Text fontWeight="bold" fontSize="md" color="#4F4F4F">
                  Job Subscription
                </Text>
                <Text fontSize="sm" color="#868585" mt={1}>
                  Post your first 3 jobs free. Attract top talent and hire faster - all in one platform.
                </Text>
              </Box>
            </VStack>
            <Button
              size="sm"
              minW="120px"
              borderRadius="20px"
              variant="primary"
              onClick={(e) => {
                e.stopPropagation();
                // setActiveSubView('job');
                setSelectedCompany(null);
                setActiveSubView('job');
                setTabIndex(1);
              }}
            >
              Manage Jobs
            </Button>
          </VStack>
        </Card>

        {/* myBridge Premium Card */}
        <Card 
          variant="thinBorderedCard" 
          p={5} 
          cursor="pointer" 
          onClick={() => { 
            setActiveSubView('premium'); 
            setTabIndex(2); 
          }} 
          position="relative"
          borderWidth="1px" 
          borderRadius="12px"
          boxShadow="sm"
          transition="all 0.2s"
          _hover={{
            boxShadow: 'md',
          }} 
        >
          <VStack align="start" spacing={4} height="100%" justifyContent="space-between">
            <VStack align="start" w="100%">
              <HStack justifyContent="space-between" w="100%">
                <MyBridgeSupscriptionIcon />
                <ArrowRight color="#868585" />
              </HStack>
              <Box>
                {!isPremiumSubscribed ? (
                  <>
                    <Text fontWeight="bold" fontSize="md" color="#4F4F4F">
                      Try Premium for $0
                    </Text>
                    <Text fontSize="sm" color="#868585" mt={1}>
                      Stand out with Premium. Enjoy unlimited profile visibility, greater exposure, and exclusive member benefits.
                    </Text>
                  </>
                ) : (
                  <>
                    <Text fontWeight="bold" fontSize="md" color="#4F4F4F">
                      myBridge Premium
                    </Text>
                    <Text fontSize="sm" color="#868585" mt={1}>
                      {premiumSubscriptionDetails?.trial_end || premiumSubscriptionDetails?.is_trial ? (
                        `You're currently on a free trial for myBridge Premium until ${moment(premiumSubscriptionDetails?.expires_at).format('MMMM Do YYYY')}.`
                      ) : (
                        `Your myBridge Premium will renew on ${moment(premiumSubscriptionDetails?.expires_at).format('MMMM Do YYYY')}.`
                      )}
                    </Text>
                  </>
                )}
              </Box>
            </VStack>
            {!isPremiumSubscribed ? (
              <Button
                size="sm"
                borderRadius="20px"
                variant="primary"
                onClick={(e) => {
                  e.stopPropagation();
                  setActiveSubView('premium');
                  setTabIndex(2);
                }}
              >
                Try premium free
              </Button>
            ) : (
              <Button
                size="sm"
                borderRadius="20px"
                variant="primary"
                onClick={(e) => {
                  e.stopPropagation();
                  setActiveSubView('premium');
                  setTabIndex(2);
                }}
              >
                Manage
              </Button>
            )}
          </VStack>
        </Card>
      </SimpleGrid>
    </VStack>
  );

  return (
    <AuthenticatedProviders>
      <Head>
        <title>{loggedIn && globalNotifCount ? `(${globalNotifCount})` : ''} {t('otherModules.settings') || "Settings"} - {t('setting.subscriptions') || "Subscriptions"} | myBridge.me</title>
      </Head>
      <Box maxW="100%" minW={0}>
        {activeSubView === null ? (
          renderDashboard()
        ) : (
          <>
            {!isMobileOnly && <HStack mb={4} cursor="pointer" onClick={() => {
              setSelectedCompany(null);
              setActiveSubView(null);
            }}>
              <BackArrow />
              <Text fontWeight="semibold" color="brandPrimary.500">Back to Subscriptions</Text>
            </HStack>}
            <Tabs index={tabIndex} onChange={(index) => setTabIndex(index)}>
              {/* <TabList w={isMobile ? "100%" : ""} borderBottom="none">
                <Tab 
                  w={isMobile ? "100%" : ""} 
                  fontSize={isMobile ? "small" : "20px"}
                  paddingBottom="3px"
                  fontWeight="500"
                  color="#5B5B5B"
                  _selected={{ color: '#3D5A80', borderBottom: '3px solid #3D5A80' }}
                >
                  {t('settingsSubscription.diskSubscription') || "Disk Subscription"}
                </Tab>
                <Tab
                  w={isMobile ? "100%" : ""} 
                  fontSize={isMobile ? "small" : "20px"}
                  paddingBottom="3px"
                  fontWeight="500"
                  color="#5B5B5B"
                  _selected={{ color: '#3D5A80', borderBottom: '3px solid #3D5A80' }}
                >
                  {t('settingsSubscription.jobSubscription') || "Job Subscription"}
                </Tab>
              </TabList> */}
              <TabPanels maxW="100%" minW={0}>
                <TabPanel p={0} maxW="100%" minW={0}>
              {paymentModal ? (
                <Box>
                  <Text
                    my={3}
                    fontSize="18px"
                    fontWeight="bold"
                    color="#3D5A80"
                  >
                    {selectedPlan.id < currentPlanID
                      ? t('settingsSubscription.downgradePlan') || 'Downgrading plan?'
                      : t('settingsSubscription.diskSubscriptions') || 'Disk subscriptions'}
                  </Text>
                  {/* <Flex justifyContent="space-between" my="15px">
                    <Box>
                      <Text fontWeight="bold" textTransform="capitalize">
                        {selectedPlan?.plan_name} (
                        {diskBilledAs.replace('price_', '')})
                      </Text>
                    </Box>
                    <Text>
                      {'$' +
                        (selectedPlan.id === 1
                          ? selectedPlan.amount
                          : selectedPlan[selectedPlanPeriod]) +
                        (diskBilledAs === 'price_monthly' ? '/mo' : '/yr')}
                    </Text>
                  </Flex> */}
                  {(() => {
                    // const rawPrice = parseFloat(
                    //   selectedPlan?.id === 1
                    //     ? selectedPlan?.amount
                    //     : selectedPlan?.[selectedPlanPeriod]
                    // ) || 19.99;
                    const rawPrice = parseFloat(
                      selectedPlan?.id === 1
                        ? selectedPlan?.amount
                        : selectedPlan?.[selectedPlanPeriod || (diskBilledAs === 'price_monthly' ? 'month_amount' : 'year_amount')]
                    ) || 0;
                    
                    const discountVal = appliedOffer?.valid ? (appliedOffer.discount_amount || 0) : 0;
                    // const finalPrice = Math.max(0, rawPrice - discountVal).toFixed(2);
                    const finalPrice = appliedOffer?.final_amount != null ? Number(appliedOffer.final_amount).toFixed(2) : Math.max(0, rawPrice - discountVal).toFixed(2);
                    const periodLabel = diskBilledAs === 'price_monthly' ? '/mo' : '/yr';

                    return (
                      <Box my="15px">
                        {/* Plan Line */}
                        <Flex justifyContent="space-between" alignItems="center" mb="8px">
                          <Text fontWeight="bold" textTransform="capitalize">
                            {selectedPlan?.plan_name || 'Professional'} (
                            {diskBilledAs?.replace('price_', '')})
                          </Text>
                          <Text fontWeight="bold">
                            {'$' + rawPrice.toFixed(2) + periodLabel}
                          </Text>
                        </Flex>
                        {appliedOffer?.valid ? (
                          <Flex justifyContent="space-between" alignItems="center" my="8px">
                            <HStack spacing={2}>
                              <Text fontSize="sm" color="green.600" fontWeight="medium">
                                {appliedOffer.name || appliedOffer.code} ({appliedOffer.code})
                              </Text>
                              <Box
                                as="button"
                                fontSize="xs"
                                color="gray.400"
                                _hover={{ color: 'red.500', textDecoration: 'underline' }}
                                onClick={handleRemoveOffer}
                              >
                                Remove
                              </Box>
                            </HStack>
                            <Text fontSize="sm" fontWeight="bold" color="green.600">
                              -{'$' + (appliedOffer.discount_amount || 0).toFixed(2) + periodLabel}
                            </Text>
                          </Flex>
                        ) : !showOfferInput ? (
                          <Box my="8px">
                            <Box
                              as="button"
                              fontSize="sm"
                              color="green.600"
                              fontWeight="semibold"
                              _hover={{ textDecoration: 'underline' }}
                              onClick={() => setShowOfferInput(true)}
                            >
                              Apply Promo Code
                            </Box>
                          </Box>
                        ) : (
                          <Box my="8px">
                            <InputGroup size="sm">
                              <Input
                                placeholder="Enter offer code"
                                value={offerCodeInput}
                                onChange={(e) => setOfferCodeInput(e.target.value)}
                                borderRadius="8px"
                                pr="75px"
                              />
                              <InputRightElement width="70px" pr="4px">
                                {offerCodeInput?.length ? (
                                  <Button
                                    size="xs"
                                    variant="transparent"
                                    isLoading={offerLoading}
                                    onClick={handleApplyOffer}
                                    height="26px"
                                  >
                                    Apply
                                  </Button>
                                ) : (
                                  <IconButton
                                    size="xs"
                                    variant="transparent"
                                    icon={<CloseIcon width="10px" height="10px" color="gray.500" />}
                                    onClick={() => {
                                      setShowOfferInput(false);
                                      setOfferCodeInput('');
                                      setOfferError('');
                                    }}
                                  />
                                )}
                              </InputRightElement>
                            </InputGroup>
                            {offerError && (
                              <Text color="red.500" fontSize="xs" mt={1}>
                                {offerError}
                              </Text>
                            )}
                          </Box>
                        )}

                        {/* Total Amount Line */}
                        <Flex
                          justifyContent="space-between"
                          alignItems="center"
                          pt="10px"
                          mt="8px"
                          borderTop="1px dashed"
                          borderColor="gray.200"
                        >
                          <Text fontWeight="bold" fontSize="md" color="#3D5A80">
                            Total Amount
                          </Text>
                          <Text fontWeight="bold" fontSize="lg" color="#3D5A80">
                            {'$' + finalPrice + periodLabel}
                          </Text>
                        </Flex>
                      </Box>
                    );
                  })()}
                  {/* <Flex justifyContent="space-between" my="15px">
                    <Box>
                      <Text fontWeight="bold" textTransform="capitalize">
                        Due today
                      </Text>
                    </Box>
                    <Text>
                      {'$' + (selectedPlan.id === 1 ? selectedPlan.amount : selectedPlan[selectedPlanPeriod])}
                    </Text>
                  </Flex> */}
                  {defaultCard ? (
                    <Flex
                      justifyContent="space-between"
                      alignItems="center"
                      my="15px"
                    >
                      <Box
                        as="button"
                        color="brandPrimary.500"
                        fontSize={["sm", "md"]}
                        onClick={() => {
                          setSelectedComponent('billing-and-payment');
                        }}
                      >
                        {t('settingsSubscription.changeCard') || "Change Card"}
                      </Box>
                      <Flex>
                        {displayCardIcon(defaultCard?.card?.brand)}
                        <Box
                          as="span"
                          fontSize={["sm", "md"]}
                        >{`${t('settingsSubscription.visaEndingIn') || "Visa ending in"} ${defaultCard?.card?.last4}`}</Box>
                      </Flex>
                      <Box fontSize={["sm", "md"]}>{`${defaultCard?.card?.exp_month}/${defaultCard?.card?.exp_year}`}</Box>
                    </Flex>
                  ) : (
                    <Flex
                      justifyContent="space-between"
                      alignItems="center"
                      my="15px"
                    >
                      <Link href="/settings/billing-and-payment">
                        <HStack>
                          <Text fontSize={["sm", "md"]} color="#333333">
                            {t('settingsSubscription.addNewCard') || "To continue, add New Credit or Debit card"}
                          </Text>{' '}
                          <CirclePlusBg />
                        </HStack>
                      </Link>
                    </Flex>
                  )}

                  <hr />
                  <HStack w="100%" justifyContent="flex-end" mt="15px">
                    <Button
                      borderRadius={"30px"}
                      variant="outline"
                      onClick={handleClose}
                    >
                      {t('buttons.back') || "Back"}
                    </Button>
                    <Button
                      borderRadius={"30px"}
                      variant="primary"
                      onClick={() => handlePaymentSubmit(selectedPlan)}
                      isDisabled={!defaultCard}
                    >
                      {t('myDisk.submit') || "Submit"}
                    </Button>
                  </HStack>
                </Box>
              ) : (
                <>
                  {!loading ? (
                    <>
                      <RadioGroup defaultValue="price_monthly" display="flex" alignItems="center" gap="10px">
                      <Radio
                        value="price_monthly"
                        onChange={handleDiskBilledAs}
                        name="billed_as"
                        // size="lg"
                        me={!isMobile && "20px"}
                        isChecked={diskBilledAs === 'price_monthly'}
                        display="flex"
                        alignItems="stretch"
                        fontSize={isMobile ? "small" : ""}
                        width={isMobile ? "92%" : ""}
                      >
                        {t('settingsSubscription.billedMonthly') || "Billed monthly"}
                      </Radio>
                      <Radio
                        value="price_yearly"
                        onChange={handleDiskBilledAs}
                        name="billed_as"
                        // size="lg"
                        isChecked={diskBilledAs === 'price_yearly'}
                        display="flex"
                        alignItems="stretch"
                        fontSize={isMobile ? "small" : ""}
                        width={isMobile ? "85%" : ""}
                      >
                        {t('settingsSubscription.billedYearly') || "Billed yearly"}
                      </Radio>
                      </RadioGroup>
                      {!isMobile ? (
                        <Box
                          w="100%"
                          maxW="100%"
                          mt="30px"
                          border="1px solid"
                          borderColor="brandGray.500"
                          borderRadius="20px"
                          overflow="hidden"
                        >
                          <TableContainer
                            overflowX="auto"
                            w="100%"
                            maxW="100%"
                            sx={{
                              '&::-webkit-scrollbar': {
                                height: '4px',
                                width: '4px',
                              },
                              '&::-webkit-scrollbar-track': {
                                background: '#f1f1f1',
                                borderRadius: '4px',
                              },
                              '&::-webkit-scrollbar-thumb': {
                                background: '#c1c1c1',
                                borderRadius: '4px',
                              },
                              '&::-webkit-scrollbar-thumb:hover': {
                                background: '#a8a8a8',
                              },
                              scrollbarWidth: 'thin',
                              scrollbarColor: '#c1c1c1 #f1f1f1',
                            }}
                          >
                            <Table
                              width="100%"
                              minW="800px"
                              variant="unstyled"
                              overflow="hidden"
                              style={{
                                borderCollapse: 'separate',
                                borderSpacing: 0
                              }}
                              sx={{
                                'th:nth-child(3), td:nth-child(1)': {
                                  backgroundColor: '#F9F9F9',
                                },
                                'th:nth-child(3), td:nth-child(3)': {
                                  backgroundColor: '#F6F7F8',
                                },
                                'th:nth-child(4), td:nth-child(4)': {
                                  backgroundColor: '#E9EAEB',
                                },
                              }}
                            >
                              <Thead>
                                <Tr>
                                  <Th
                                    borderRight="1px"
                                    borderColor="brandGray.500"
                                    // width="35%"
                                    width="225px"
                                    minWidth="225px"
                                    textAlign="center"
                                    textTransform="auto"
                                    fontSize="18px"
                                    verticalAlign="top"
                                  >
                                    <Text color="black" fontWeight="600" py={3} fontSize="20px" lineHeight="24px">
                                      {t('settingsSubscription.myDiskFeatures') || "myDisk features"}
                                    </Text>
                                  </Th>
                                  {mapSubscriptions?.map((sub, i) => (
                                    <Th
                                      borderRight="1px"
                                      borderColor="brandGray.500"
                                      minWidth="190px"
                                      textAlign="center"
                                      textTransform="auto"
                                      fontSize="18px"
                                      fontWeight='600'
                                      key={i}
                                    >
                                      <Text color="black" fontWeight="600" fontSize="20px" py={3} lineHeight="24px">
                                        {sub.plan_name}
                                      </Text>
                                      <Text
                                        my="10px"
                                        color="brandGray.600"
                                        fontWeight="normal"
                                        letterSpacing={0}
                                        fontSize="18px"
                                      >
                                        {sub.amount === 0
                                          ? t('settingsSubscription.free') || 'Free'
                                          : '$' +
                                            sub[
                                              diskBilledAs === 'price_monthly'
                                                ? 'month_amount'
                                                : 'year_amount'
                                            ] +
                                            (diskBilledAs === 'price_monthly'
                                              ? ' / mo'
                                              : ' / yr')}
                                      </Text>
                                      <Button
                                        width="130px"
                                        fontWeight="400"
                                        variant={sub.amount === 0 ? "" : "primarySub"}
                                        backgroundColor={sub.amount === 0 && "#E4E6EB"}
                                        color={sub.amount === 0 ? "#5B5B5B" : "#fff"}
                                        mt="15px"
                                        borderRadius="50px"
                                        isDisabled={
                                          sub.id === currentPlan?.disk_plan?.id
                                        }
                                        onClick={() => handleBuyPackage(sub)}
                                      >
                                        {sub.amount === 0 ? t('settingsSubscription.free') || 'Free' : t('settingsSubscription.buyNow') || 'Buy now'}
                                      </Button>
                                    </Th>
                                  ))}
                                </Tr>
                              </Thead>
                              <Tbody>
                                <Tr>
                                  <Td
                                    fontSize="14px"
                                    borderRight="1px"
                                    borderColor="brandGray.500"
                                  >
                                    <HStack w="100%" justifyContent="space-between">
                                      <Box>
                                        <Text>{t('settingsSubscription.storage') || "Storage"}</Text>
                                      </Box>
                                      <Box position="relative">
                                        <Tooltip
                                          placement="bottom"
                                          label={t('settingsSubscription.defaultSpaceInfo') || "The amount of space you recieve by default."}
                                          bg="brandGray.700"
                                        >
                                          <Box as="react-icons">
                                            <QuestionOutlineIcon />
                                          </Box>
                                        </Tooltip>
                                      </Box>
                                    </HStack>
                                  </Td>
                                  {mapSubscriptions.map((item, i) => (
                                    <Td
                                      fontSize="14px"
                                      borderRight="1px"
                                      borderColor="brandGray.500"
                                      textAlign="center"
                                      key={i}
                                    >
                                      {item.id === 1
                                        ? `${item?.storage?.slice?.(0, 1)}GB`
                                        : `${item?.storage?.slice?.(0, 1)}TB`}
                                    </Td>
                                  ))}
                                </Tr>
                                {allSubscriptions['BASIC']?.map((item, i) => (
                                  <Tr key={i}>
                                    <Td
                                      fontSize="14px"
                                      borderRight="1px"
                                      borderColor="brandGray.500"
                                    >
                                      <HStack
                                        w="100%"
                                        justifyContent="space-between"
                                      >
                                        <Box>
                                          <Text>{item.name}</Text>
                                        </Box>
                                        <Box position="relative">
                                          <Tooltip
                                            placement="bottom"
                                            label={`${item.description}`}
                                            bg="brandGray.700"
                                          >
                                            <Box as="react-icons">
                                              <QuestionOutlineIcon />
                                            </Box>
                                          </Tooltip>
                                        </Box>
                                      </HStack>
                                    </Td>
                                    <Td
                                      borderRight="1px"
                                      borderColor="brandGray.500"
                                      textAlign="center"
                                    >
                                      <Icon as={CheckMark} />
                                    </Td>
                                    <Td
                                      borderRight="1px"
                                      borderColor="brandGray.500"
                                      textAlign="center"
                                    >
                                      <Icon as={CheckMark} />
                                    </Td>
                                    <Td
                                      borderRight="1px"
                                      borderColor="brandGray.500"
                                      textAlign="center"
                                    >
                                      <Icon as={CheckMark} />
                                    </Td>
                                  </Tr>
                                ))}
                              </Tbody>
                            </Table>
                          </TableContainer>
                        </Box>
                      ) : (
                        <>
                          <Text
                            color="black"
                            fontWeight="400"
                            fontSize="20px"
                            py={3}
                          >
                            {t('settingsSubscription.myDiskFeatures') || "myDisk features"}
                          </Text>

                          <VStack w="100%" p="10px" gap="16px">
                            {mapSubscriptions?.map((sub, i) => (
                              <Card key={i} w="100%" className="mobilePlanCards">
                                <CardHeader textAlign="center">
                                  <Text fontWeight="400" fontSize="20px">
                                    {sub.plan_name}
                                  </Text>
                                  <Text
                                    mt="10px"
                                    color="brandGray.600"
                                    fontWeight="normal"
                                    letterSpacing={0}
                                    fontSize="18px"
                                  >
                                    {sub.amount === 0
                                      ? t('settingsSubscription.free') || 'Free'
                                      : '$' +
                                        sub[
                                          diskBilledAs === 'price_monthly'
                                            ? 'month_amount'
                                            : 'year_amount'
                                        ] +
                                        (diskBilledAs === 'price_monthly'
                                          ? ' / mo'
                                          : ' / yr')}
                                  </Text>
                                  <Button
                                    width="150px"
                                    variant="primarySub"
                                    mt="15px"
                                    isDisabled={
                                      sub.id === currentPlan?.disk_plan?.id
                                    }
                                    onClick={() => handleBuyPackage(sub)}
                                  >
                                    {sub.amount === 0 ? t('settingsSubscription.free') || 'Free' : t('settingsSubscription.buyNow') || 'Buy now'}
                                  </Button>
                                </CardHeader>
                                <CardBody p={0}>
                                  <VStack
                                    divider={
                                      <StackDivider borderColor="gray.200" />
                                    }
                                    spacing={1}
                                    align="stretch"
                                  >
                                    {allSubscriptions['BASIC']?.map(
                                      (item, i) => (
                                        <HStack key={i} p="10px" justifyContent="space-between">
                                          <HStack>
                                          <Tooltip
                                            placement="bottom"
                                            label={`${item.description}`}
                                            bg="brandGray.700"
                                          >
                                            <Box as="react-icons">
                                              <QuestionOutlineIcon />
                                            </Box>
                                          </Tooltip>
                                          <Text fontSize="sm">{item.name}</Text>
                                          </HStack>
                                          <Icon as={CheckMark} />
                                        </HStack>
                                      )
                                    )}
                                  </VStack>
                                </CardBody>
                              </Card>
                            ))}
                          </VStack>
                        </>
                      )}
                    </>
                  ) : (
                    <SectionLoader />
                  )}
                </>
              )}
            </TabPanel>

            {/* Tab for Job Subscriptions */}
            <TabPanel>
              {selectedCompany ? (
                <JobSubscriptionPage selectedCompany={selectedCompany}  setSelectedCompany={setSelectedCompany} fromSettings={fromSettings}/>
              ) : (
                <Stack
                  width="100%"
                  // justifyContent="center"
                  alignItems="start"
                  minH="400px"
                  position="relative"
                >
                  {/* <Text fontSize="20px" fontWeight="600">Please select a page to view or purchase subscription</Text> */}
                  <Box w="100%" maxW={isMobile ? "328px" : "580px"} mb={10}>
                    <HStack
                      flexDir={['column', 'column', 'row']}
                      alignItems="flex-start"
                      justifyContent="space-between"
                    >
                      <Text color="#737373" fontWeight="400" lineHeight="24px" padding="8px 0">{t('createJob.hiringAuthority') || "Hiring Authority"}*</Text>
                    <Link href="/page/create">
                      <Text
                        fontSize="16px"
                        color="brandPrimary.500"
                        fontWeight="semibold"
                        display="flex"
                        alignItems="center"
                        justifyContent="end"
                        padding="10px 0"
                        gap="8px"
                      >
                        <AddCircleFIlled height="24px" width="24px" />  {t('createJob.createCompany') || "Create company"}
                      </Text>
                    </Link>
                    </HStack>
                    <Select
                      borderRadius="27px"
                      border="1px solid #737373"
                      width="253px"
                      value={selectedCompany || ''}
                      onChange={(e) => setSelectedCompany(e.target.value)}
                      variant="whiteInput"
                      placeholder={t('settingsSubscription.selectPage') || "Select Page"}
                      style={{color: '#737373'}}
                      sx={direction === 'rtl' ? {
                        '&': {
                          textAlign: 'left',
                        }
                      } : {}}
                    >
                      {companyPageTypeList?.filter(pages => pages.access_type==='owner')?.map((company, i) => (
                        <option key={i} value={company.id}>
                            {company.name?.length>25?company.name?.slice(0, 25)+"...":company?.name}
                        </option>
                      ))}
                    </Select>
                  </Box>
                  <Box
                    position="absolute"
                    top="80%"
                    left="50%"
                    transform="translate(-50%, -50%)"
                  >
                    <JobsNotFoundIllustration />
                  </Box>
                </Stack>
              )}
            </TabPanel>

            <TabPanel>
              <PremiumSubscription />
            </TabPanel>
          </TabPanels>
        </Tabs>
          </>
        )}
      </Box>

      {/* <Modal
        isOpen={paymentModal && defaultCard}
        onClose={() => setPaymentModal(false)}
        size="xl"
        isCentered
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Disk subscriptions</ModalHeader>
          <ModalCloseButton />
          <ModalBody></ModalBody>

          <ModalFooter>
            <Button
              variant="primary"
              onClick={() => handlePaymentSubmit(selectedPlan)}
            >
              Submit
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal> */}
    </AuthenticatedProviders>
  );
}